import { useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { api } from "@/lib/api";

const TREND_ICON = {
  up: ArrowUpRight,
  down: ArrowDownRight,
  flat: Minus,
};

const TREND_COLOR = {
  up: "text-[#4FD1B8]",
  down: "text-[#E08A8A]",
  flat: "text-[#8FA2B3]",
};

export function MarketTicker() {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    api.get("/market-ticker").then(({ data }) => setCities(data)).catch(() => {});
  }, []);

  if (cities.length === 0) return null;

  return (
    <div className="bg-[#10243A] border-b border-black/10" data-testid="market-ticker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center gap-x-6 gap-y-1 overflow-x-auto">
        <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#C47A35] whitespace-nowrap shrink-0">
          Metri<span className="text-white">.bg</span> Метър сега
        </span>
        <div className="flex items-center gap-5 sm:gap-8 font-mono">
          {cities.map((c) => {
            const Icon = TREND_ICON[c.trend] || Minus;
            return (
              <div key={c.slug} className="flex items-center gap-1.5 whitespace-nowrap" data-testid={`market-ticker-city-${c.slug}`}>
                <span className="text-xs font-medium text-[#C8D3DC] font-sans">{c.city}</span>
                <span className="text-xs text-white font-semibold">{Math.round(c.price_per_sqm).toLocaleString("bg-BG")} €/кв.м</span>
                <Icon className={`w-3.5 h-3.5 ${TREND_COLOR[c.trend] || "text-[#8FA2B3]"}`} data-testid={`market-ticker-trend-${c.slug}`} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
